import PledgeLogo from "../images/pledge/pledge-logo.png";
const EnvironmentalSustanabilityPledge = () =>{
      return (
  
        <main>
          <section className="banner">
            <div className="container">
              <div className="Pledge-inner">
                <div className="pledge-inner-box">
                  <div className="Pledge-inner-img">
                    {/* <img src={PledgeLogo} className="img-fluid" alt="" /> */}
                  </div>
                  <h2 style={{fontWeight: '600'}}>Environmental Sustainability Pledge</h2>
                </div>
                <div className="pledge-inner-content">
                  <h4>Last Updated: 05 - July - 2024</h4>
                  <p>
                    At VECTRA International, we are committed to doing our part to protect the environment and
                    promote sustainability. We recognize that our operations and business activities have an
                    impact on the environment, and we are committed to minimizing that impact through
                    responsible practices and policies. To that end, we pledge to:
                  </p>
                  <p>
                    Promote responsible business practices:
                    We are a leading global responsible business consulting firm. We work with our clients to
                    promote responsible business practices and help them achieve ESG (environmental, social, and
                    governance) standards.
                  </p>
                  <p> 
                    Reduce our carbon footprint:
                    We will take steps to reduce our carbon emissions and promote energy efficiency, such as
                    using
                    renewable energy sources, reducing waste, and optimizing our transportation and logistics.
                  </p>
                  <p>
                    Promote waste reduction and recycling:
                    We will strive to reduce waste and increase recycling in our operations and will work to
                    minimize the use of disposable items and packaging.
                  </p>
                  <p>
                    Use sustainable materials and products:
                    We will seek out and use sustainable materials and products whenever possible and will encourage
                    our suppliers and vendors to do the same.
                  </p>
                  <p>
                    Protect natural resources:
                    We will take steps to protect natural resources, such as conserving water, minimizing our use of
                    hazardous materials, and avoiding activities that can harm ecosystems and wildlife.
                  </p>
                  <p>
                    Educate and engage our employees:
                    We will provide ongoing education and training to our employees on environmental sustainability
                    and will encourage them to take action to reduce their own environmental impact.
                  </p>
                  <p>
                    Collaborate with our stakeholders:
                    We will work collaboratively with our customers, suppliers, partners, and other stakeholders to
                    promote environmental sustainability and create a more sustainable future.
                  </p>
                  <p>
                    Reduce our environmental footprint:
                    We will take steps to minimize our environmental impact, including reducing waste, conserving
                    energy, and transitioning to sustainable practices and materials wherever possible.
                  </p>
                  <p>
                    We recognize that achieving environmental sustainability is an ongoing journey, and we are
                    committed to continuously learning and improving. By making this pledge, we are committing to
                    promoting sustainable practices and policies throughout our business activities, and to creating
                    a more sustainable future for generations to come.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </main>
      );
    };
    export default EnvironmentalSustanabilityPledge